import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import port from "../img/portfolio.jpg";
import "./Portfolio.css";

function Portfolio() {
  const [portfolioItems, setPortfolioItems] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPortfolio = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/public/portfolio`,
          { withCredentials: true }
        );
        setPortfolioItems(response.data);
      } catch (error) {
        console.error("Error fetching portfolio data:", error.message);
      }
    };

    fetchPortfolio();
  }, []);

  return (
    <div className="portfolio-section">
 
      <div className="portfolio-container">
        <img src={port} alt="portfolio background" />
        <div className="portfolio-hero-text">
          "Blending Realities. Building Experiences."
        </div>
      </div>

 
      <div className="portfolio-card-container-title">Portfolio</div>


      <div className="portfolio-card-container">
        {portfolioItems.map((item) => (
          <div
            key={item._id}
            className="portfolio-card"
            onClick={() => navigate(`/portfolio/${item._id}`)} 
          >
            <img src={item.image1} alt={item.title} className="portfolio-img" />
            <div className="portfolio-overlay">{item.title}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Portfolio;
